class SafeLoadScripts extends HTMLElement {
  constructor() {
    super();
  }


  connectedCallback() {
    const scripts = this.querySelectorAll('safe-load-scripts > script');

    scripts.forEach((script) => {
      const key = script.dataset.flowLoadKey;

      const scriptLoaded = window.wetheme.webcomponentRegistry.checkScriptLoaded(key);
      if(!scriptLoaded) {
        const postLoadedScript = document.createElement('script');
        const {src, defer, async, type} = script;
        postLoadedScript.src = src;
        postLoadedScript.defer = defer;
        postLoadedScript.async = async;
        postLoadedScript.type = type;


        this.parentElement.appendChild(postLoadedScript);

      }
    })

  }
}
  
customElements.define('safe-load-scripts', SafeLoadScripts);


$(document).ready(function(){
     if(document.body.classList.contains('template-landing')){
       var isALARendered;
        function ALAcheck() {
         isALARendered = setInterval(function () {
         customALA()
         }, 2000);
        }
      ALAcheck();
      function customALA() {
              if($('.rc-radio__input.rc_widget__option__input').length > 0) {
                console.log($('.rc-radio__input.rc_widget__option__input').length);
               clearInterval(isALARendered); 
                  $('[data-radio-onetime]').click(function(){
                   $('.js-qty__adjust--plus').click();
                 })
                $('[data-radio-subsave]').click(function(){
                  //console.log("minus.dfjsdkghny");
                   $('.js-qty__adjust--minus').click();
                 })
              } 
        }
    }
});